var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Buttons"},_vm._l((_vm.validButtons),function(btn){return _c('OptionButton',{key:("btn_" + (btn.id)),attrs:{"data":btn},on:{"select":_vm.onClickButton}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }